<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-button style="float:right"
                   size="medium"
                   v-has="'Create Task Group'"
                   @click="openGroupDialog()"
                   type="primary">{{$t('group.NewTaskGroup')}}</el-button>
      </template>
      <template slot="search">
        <el-row :gutter="20">
          <el-col :lg="8"
                  :md="6">
            <el-input :placeholder="$t('group.SearchTaskGroupName')"
                      v-model="condition.Name"
                      @change="search()"
                      size="mini"
                      clearable></el-input>
          </el-col>
        </el-row>
      </template>
    </sub-header>
    <div class="main"
         v-if="data.length>0"
         :class="{'main-showfilter': taskDialog.showDialog}">
      <div class="list">
        <myScroll style="width:100%;height:100%">
          <el-table :data="data"
                    size="small"
                    :row-class-name="tableRowClassName"
                    @row-click="changeDetail"
                    style="position:absolute"
                    :show-header="false">
            <el-table-column>
              <template slot-scope="scope">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="text">
                      <div class="name">{{scope.row.Name}}</div>
                      <div class="date">
                        <span style="width:70px;display:inline-block;">{{scope.row.StartDate?scope.row.StartDate.substring(0,10):''}}</span>
                        <span style="margin:0 5px;">{{scope.row.StartDate || scope.row.DueDate ? '-':''}}</span>
                        <span style="width:70px;display:inline-block;">{{scope.row.DueDate?scope.row.DueDate.substring(0,10):''}}</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="11">
                    <el-progress :percentage="scope.row.Progress"></el-progress>
                    <div class="tasknumbers">{{scope.row.AllTaskCount}} {{$t('group.Tasks')}}</div>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
        <page :total="total"
              :PageSize="condition.PageSize"
              :PageIndex="condition.PageIndex"
              @handleCurrentChange="handleCurrentChange"></page>
      </div>
      <div class="detail">
        <div class="detail-content">
          <div class="chart-box">
            <div class="chart-name">
              <span>{{detail.Name}}</span>
              <div style="float:right">
                <el-button type="primary"
                           size="small"
                           @click="openGroupDialog(detail.PhaseId)"
                           v-has="'Edit Task Group'">{{$t('group.Edit')}}</el-button>
                <el-dropdown @command="handleNewReportCommand"
                             style="margin-left:10px;margin-right:10px;"
                             v-has="'Create Report'">
                  <el-button type="primary"
                             size="small">
                    {{$t('task.NewReport')}}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{Type:0, Name:$t('task.Task')}">{{$t('task.Task')}}</el-dropdown-item>
                    <el-dropdown-item :command="{Type:1, Name:$t('task.ProductInstallation')}">{{$t('task.ProductInstallation')}}</el-dropdown-item>
                    <el-dropdown-item :command="{Type:2, Name:$t('task.Moisture')}">{{$t('task.Moisture')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary"
                           v-has="'Edit Task Group'"
                           :disabled="detail.AllTaskCount < 1"
                           size="small"
                           @click="saveAsTaskTemplateDialog(detail.PhaseId)">{{$t('group.SaveAsTaskTemplate')}}</el-button>
                <el-dropdown v-has="'Delete Task Group'"
                             @command="deleteTaskGroup"
                             trigger="click"
                             style="margin-left:10px;vertical-align: middle;cursor:pointer">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"
                       style="transform: rotate(90deg)"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">
                      <el-link :underline="false"
                               type="danger">{{$t('group.Delete')}}</el-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="chart-due">
              <span style="width:70px;display:inline-block;">{{detail.StartDate?detail.StartDate.substring(0,10):''}}</span>
              <span style="margin:0 5px;">{{detail.StartDate || detail.DueDate ? '-':''}}</span>
              <span style="width:70px;display:inline-block;">{{detail.DueDate?detail.DueDate.substring(0,10):''}}</span>
            </div>
            <el-progress :percentage="detail.Progress"></el-progress>
            <div class="chart">
              <div id="myChart"
                   :style="{width: '100%', height: '100%'}"></div>
            </div>
          </div>
          <div class="task-box"
               v-loading="taskLoading">
            <div class="tab">
              <el-tabs v-model="tab"
                       @tab-click="handleClick"
                       size="mini">
                <el-tab-pane :label="$t('group.Open', [detail.OpenTaskCount])"
                             name="Open"></el-tab-pane>
                <el-tab-pane :label="$t('group.Complete', [detail.CompletedTaskCount])"
                             name="Complete"></el-tab-pane>
              </el-tabs>
            </div>

            <myScroll style="width:100%; height:70%">
              <el-table size="small"
                        :data="taskData"
                        style="position:absolute"
                        @row-click="showTaskDialog"
                        :show-header="false">
                <el-table-column width="50">
                  <template slot-scope="scope">
                    <svg-icon :iconClass="scope.row.icon"
                              :class="scope.row.color"></svg-icon>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    {{scope.row.Name}}
                    <div class="status">
                      <p v-if="scope.row.TaskType !== 2"
                         :class="scope.row.color"
                         style="margin:0"> {{$t('group.Progress')}}:{{scope.row.CompletionRate}}%</p>
                      <p v-if="scope.row.TaskType === 2"
                         :class="scope.row.color"
                         style="margin:0"> {{$t('group.Concrete')}}:{{scope.row.Concrete}}%</p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </myScroll>
            <div class="task-page">
              <el-pagination layout="prev, pager, next"
                             :total="taskTotal"
                             @current-change="handleTaskChange"
                             :current-page.sync="taskCondition.PageIndex"
                             :page-size="10">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.length === 0"
         class="no-data">
      {{$t('group.NoData')}}
    </div>
    <Group-Dialog :showDialog="groupDialog.showDialog"
                  @closeDialog="closeGroupDialog"
                  :id="groupDialog.id"></Group-Dialog>
    <Task-dialog :showDialog="taskDialog.showDialog"
                 @closeDialog="closeTaskDialog()"
                 :id="taskDialog.id"></Task-dialog>
    <reportConditionDialog :showDialog="newReportDialog.show"
                           :groupId="currentId"
                           :type="newReportDialog.type"
                           @closeDialog="closeNewReportDialog">
    </reportConditionDialog>
    <Task-Template-Dialog :showDialog="taskTemplateDialog.showDialog"
                          @closeDialog="closeTaskTemplateDialog"
                          :id="taskTemplateDialog.id"
                          :name="taskTemplateDialog.name"></Task-Template-Dialog>
  </div>
</template>

<script>
import {
  getTaskGroup,
  getTaskGroupById,
  getTasksList,
  deleteTaskGroup
} from '@/api/config'
import GroupDialog from '@components/group/groupDialog'
import TaskDialog from '@components/task/taskDialog'
import { mapState } from 'vuex'
import { EleResize } from '@/static/esresize'
import reportConditionDialog from '@/components/report/reportConditionDialog.vue'
import TaskTemplateDialog from '@components/group/groupTemplateDialog'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')

export default {
  data () {
    return {
      taskDialog: {
        showDialog: false,
        id: ''
      },
      groupDialog: {
        id: null,
        showDialog: false
      },
      tab: 'Open',
      taskData: [],
      taskTotal: 0,
      detail: {},
      data: [],
      total: 0,
      currentId: '',
      condition: {
        Name: null,
        PageIndex: 1,
        PageSize: 15,
        AllowLoadTaskCount: true,
        OrderBy: 'CreatedOn desc',
        GetRecycle: false
      },
      newReportDialog: {
        show: false,
        type: 1
      },
      taskCondition: {
        JobsiteId: this.jobsiteID,
        PageIndex: 1,
        PageSize: 20,
        GetChildTask: false,
        GetRecycle: false,
        IsApp: false,
        AllowLoadLastRHReading: true,
        OrderBy: 'LastUpdatedOn desc'
      },
      taskLoading: false,
      taskTemplateDialog: {
        id: null,
        name: null,
        showDialog: false
      }
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'preJobsiteID', 'userInfo'])
  },
  created () {
    this.$store.dispatch('getTasksStatus')
    this.getTaskGroup('init')
  },
  mounted () {
  },
  watch: {
    currentId (to, from) {
      this.getTaskGroupById()
    }
  },
  methods: {
    handleNewReportCommand (commmand) {
      this.newReportDialog.show = true
      this.newReportDialog.type = commmand.Type === 1 ? 1 : commmand.Type === 2 ? 4 : 5
    },
    closeNewReportDialog (needRefresh) {
      this.newReportDialog.show = false
      if (needRefresh === true) {
        this.$notify({
          title: this.$t('task.NewReport') + ' ' + this.$t('api.Successfully'),
          type: 'success',
          showClose: false,
          duration: 3000
        })
      }
    },
    search () {
      this.getTaskGroup('init')
    },
    getTaskGroup (init) {
      this.condition.JobsiteId = this.jobsiteID
      getTaskGroup(this.condition).then(res => {
        this.data = res.Data
        this.data.forEach(ele => {
          if (ele.Progress > 0) {
            ele.Progress = parseFloat(ele.Progress.toFixed(1))
          }
          if (ele.StartDate) {
            ele.StartDate = this.$config.LocalTime(ele.StartDate)
          }
          if (ele.DueDate) {
            ele.DueDate = this.$config.LocalTime(ele.DueDate)
          }
        })
        this.total = res.TotalCount
        if (init && this.data.length > 0) {
          this.currentId = this.data[0].PhaseId
          this.getTaskGroupById()
        }
      })
    },
    getTaskGroupById () {
      let time = new Date().getTimezoneOffset()
      let that = this
      getTaskGroupById(that.currentId, -time).then(res => {
        this.detail = res
        this.detail.Progress = parseFloat(this.detail.Progress.toFixed(1))
        if (this.detail.DueDate) {
          this.detail.DueDate = this.$config.LocalTime(this.detail.DueDate).substring(0, 10)
        }
        if (this.detail.StartDate) {
          this.detail.StartDate = this.$config.LocalTime(this.detail.StartDate).substring(0, 10)
        }
        let data = []
        this.detail.ChartDatas.forEach(ele => {
          let obj = {
            value: []
          }
          obj.value.push(ele.Date.substring(0, 10))
          obj.value.push(this.$config.getFormatNumber(ele.Progress))
          data.push(obj)
        })
        console.log(data)
        this.drawLine(data)
        this.getTasksList()
        let currentGroup = that.data.find(d => d.PhaseId === that.currentId)
        if (currentGroup) {
          that.detail.AllTaskCount = currentGroup.AllTaskCount
        }
      })
    },
    drawLine (data) {
      let myChart = echarts.init(document.getElementById('myChart'))
      let resdiv = document.getElementById('myChart')
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: (params) => {
            for (let x in params) {
              return params[x].data.value[0] + ' <br/> ' + params[x].data.value[1] + '%'
            }
          }
        },
        xAxis: {
          type: 'category',
          minInterval: 3600 * 24 * 1000,
          splitLine: {
            show: false
          },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: {
            formatter: (value, index) => {
              let texts = []
              if (value === 0) {
                texts.push('0%')
              } else if (value === 20) {
                texts.push('20%')
              } else if (value === 40) {
                texts.push('40%')
              } else if (value === 60) {
                texts.push('60%')
              } else if (value === 80) {
                texts.push('80%')
              } else if (value === 100) {
                texts.push('100%')
              }
              return texts
            }
          }
        },
        series: [{
          data: data,
          type: 'line',
          itemStyle: {
            normal: {
              color: '#4193f6',
              lineStyle: {
                color: '#4193f6'
              },
              label: { show: true }
            }
          }
        }]
      }
      myChart.setOption(option)
      let listener = function () {
        myChart.resize()
      }
      EleResize.on(resdiv, listener)
    },
    getTasksList () {
      this.taskLoading = true
      this.taskData = []
      if (this.userInfo.RoleType === 4) {
        this.taskCondition.AssignedUserIds = this.userInfo.UserId
      }
      this.taskCondition.GroupId = this.currentId
      if (this.tab === 'Open') {
        this.taskCondition.GetNoCompleted = true
        this.taskCondition.OnlyCompleted = null
      } else if (this.tab === 'Complete') {
        this.taskCondition.OnlyCompleted = true
        this.taskCondition.GetNoCompleted = null
      }
      getTasksList(this.taskCondition).then(res => {
        this.taskData = this.$config.handleTaskList(res.Data)
        this.taskLoading = false
      })
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getTaskGroup()
    },
    handleTaskChange (val) {
      this.taskCondition.PageIndex = val
      this.getTasksList()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (this.currentId === row.PhaseId) {
        return 'success-row'
      }
    },
    changeDetail (row) {
      this.currentId = row.PhaseId
    },
    deleteTaskGroup () {
      this.$confirm(this.$t('group.AreYouSureYouWantToDeleteThisGroup'), this.$t('group.TIPS'), {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: this.$t('group.Yes'),
        cancelButtonText: this.$t('group.No'),
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(this.currentId)
        deleteTaskGroup(params).then(res => {
          let index = this.condition.PageIndex
          if (index > 1) {
            let curTotal = this.total - 1
            let prePageTotal = (index - 1) * this.condition.PageSize
            if (curTotal <= prePageTotal) {
              this.condition.PageIndex = index - 1
            }
          }
          this.getTaskGroup('init')
        })
      }).catch(() => {
      })
    },
    handleClick (tab, event) {
      this.tab = tab.name
      this.getTasksList()
    },
    closeGroupDialog (id) {
      if (id === this.currentId) {
        this.getTaskGroupById()
        this.getTaskGroup()
      } else if (typeof (id) !== 'undefined') {
        this.getTaskGroup('init')
      }
      this.groupDialog.showDialog = false
    },
    openGroupDialog (id) {
      if (id) {
        this.groupDialog.id = id
      } else {
        this.groupDialog.id = null
      }
      this.groupDialog.showDialog = true
    },
    closeTaskDialog () {
      this.taskDialog.id = ''
      this.taskDialog.showDialog = false
      this.getTaskGroup()
      this.getTaskGroupById()
    },
    showTaskDialog (row) {
      this.taskDialog.id = row.TaskId
      this.taskDialog.showDialog = true
    },
    closeTaskTemplateDialog () {
      this.taskTemplateDialog.id = null
      this.taskTemplateDialog.name = null
      this.taskTemplateDialog.showDialog = false
    },
    saveAsTaskTemplateDialog (id) {
      this.taskTemplateDialog.id = id
      this.taskTemplateDialog.name = this.detail.Name
      this.taskTemplateDialog.showDialog = true
    }
  },
  components: {
    GroupDialog,
    TaskDialog,
    reportConditionDialog,
    TaskTemplateDialog
  }
}
</script>
<style lang="scss">
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style scoped lang="scss">
.main {
  flex-direction: row !important;
  padding: 0 8px 10px;
  .list {
    width: 450px;
    background-color: #fff;
    position: relative;
    border-radius: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .text {
      overflow: hidden;
      padding: 5px 0 0 10px;
      .name {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .date {
        color: #909399;
      }
    }
    .el-progress {
      margin-top: 8px;
    }
    .tasknumbers {
      color: #4193f6;
    }
    .group-page {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
  .detail {
    flex: 1;
    margin: 0 0 10px 10px;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    .detail-content {
      border-radius: 5px;
      background-color: #fff;
      width: 100%;
      height: 100%;
      padding: 0 5%;
      box-sizing: border-box;
      .chart-box {
        height: 50%;
        overflow: hidden;
        .chart-name {
          margin-bottom: 10px;
          margin-top: 20px;
          position: relative;
          span {
            font-size: 22px;
          }
        }
        .chart-due {
          font-size: 14px;
          color: #909399;
          margin-bottom: 5px;
        }
        .el-progress {
          width: 350px;
        }
        .chart {
          width: 100%;
          height: 30vh;
        }
        p {
          margin: 10px 0;
          color: #909399;
        }
      }
      .task-box {
        height: 50%;
        .tab {
          text-align: center;
          overflow: hidden;
          .el-tabs__item {
            height: 30px;
            line-height: 30px;
          }
        }
        .task-page {
          text-align: right;
        }
        .svg-icon {
          font-size: 28px;
        }
        .status {
          float: right;
          margin-right: 20px;
          color: #4193f6;
          min-width: 90px;
        }
        .group-page {
          text-align: right;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
